module.exports = __webpack_public_path__ + "img/img_void.257751d9.jpg";